import React from 'react';

const Playlists = () => {
  return <div className='center'>This channel doesn't have any playlists.</div>;
};

export default Playlists;
